import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const EnquiryIdLink = styled.span`
  text-decoration: ${(props) => props.decoration ?? "underline"};
  cursor: pointer;
  color: ${(props) => props.color ?? "#fff"};
`;

export const HeaderWrapperTable = styled.div`
  background-color: ${(props) => props.color ?? "#d1e6f7"};
  display: table-column-group;
  justify-content: space-between;
  padding: 10px;
  border-radius: 5px 5px 0px 0px;
`;

export const QuoteServiceInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const QuoteServicePadding = styled.section`
  padding: ${(props) => props.padding ?? "20px"};
`;

export const MargingDiv = styled.div`
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#3EBBB933"};
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  display: block;
  font-size: 16px;
  font-weight: 700;
  text-align: right;
`;

export const MarginGridSubItem = styled.div`
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.weight ?? "700"};
  font-size: 16px;
  text-align: right;
`;

export const ServiceInfo = styled.div`
  justify-self: auto;
  color: ${(props) => props?.color ?? "#767676"};
  font-size: ${(props) => props?.fontSize ?? "14px"};
  font-weight: bold !important;
  padding-left: 4px;
`;

export const GridItem = styled.div`
  border-right: ${(props) =>
    props.borderRight ?? "2px solid rgba(10, 73, 134, 0.3)"};
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: #474747;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
`;

export const HeaderGridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem;"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
  height: 2rem;
`;

export const HorizontalRow = styled.div`
  border: 1px solid rgba(10, 73, 134, 0.3);
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  > div {
    margin-right: 0.5rem;
  }
`;

export const ExchangeUl = styled.ul`
  padding: 0;
  margin: 0;
`;

export const ListTitle = styled.li`
  color: #0a4986;
  font-weight: 700;
  text-align: left;
  list-style: none;
  margin-top: 10px;
  font-size: 16px;
`;

export const ListSubTitle = styled.li`
  color: #0a4986;
  font-weight: 400;
  margin-left: 25px;
  text-align: left;
  font-size: 16px;
  margin-top: 3px;
`;

export const ExchangeValueSpan = styled.span`
  color: #474747;
`;
